// removed by extract-text-webpack-plugin
module.exports = {"button":"ApprovalForm__button___1TQoi"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/approvals/ApprovalForm.css
// module id = 1206
// module chunks = 0